<div class="sec-wrap" [attr.data-locale]="currentLocale">
  <div class="sec-area">
    <div class="sec-body">
      <!-- Header Menu -->
      <div class="menu" (click)="closeSecNav()">
        <i class="material-icons">keyboard_arrow_left</i>
        <span class="menuTxt">{{localeTexts.length ? localeTexts[2].main.menu : ''}}</span>
      </div>

      <hr class="hr-adjust">
      <div class="sec-content">

        <!-- My Bookings -->
        <!-- <div class="myBookingBox" *ngIf="contentToShow === 'My bookings'">
          <div class="banner" *ngIf="localeTexts.length" [style.backgroundImage]="'url('+ localeTexts[2].headerBanner.imageURL +')'">
            <div class="bigLogoLayer">
              <img src="{{localeTexts[2].bigLoyaltyLogo.imageURL}}" alt="Big Loyalty Logo">
            </div>
          </div>

          <div class="login">
            <aa-sso-widget [isMobileView]='true'></aa-sso-widget>
          </div>
        </div> -->

        <!-- Language -->
        <div *ngIf="contentToShow === 'lang' && sortedLangArr.length" class="langBox">
          <div class="lang">
            <span class="title">{{localeTexts.length ? localeTexts[2].main.language : ''}}</span>
          </div>
          <div class="lang" *ngFor="let item of sortedLangArr" (click)="changeLocale(item.code)">
            <span class="langName">{{item.name}}</span>
          </div>
        </div>

        <!-- Currency -->
        <div *ngIf="contentToShow === 'curr'" class="currBox">
          <div class="curr">
            <span class="title">{{localeTexts.length ? localeTexts[2].main.currency : ''}}</span>
          </div>
          <div class="curr" *ngFor="let c of sortedLangKeys" (click)="changeCurrency(c, localeTexts[1].currency[c])">
            <span class="currCode">{{c}}</span>
            <span class="currName">{{localeTexts[1].currency[c]}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="closeSecMark" (click)="closeSecNav()">
    <div class="x">
      <i class="material-icons">clear</i>
    </div>
    <div class="menu">
      <i class="material-icons">menu</i>
    </div>
  </div>
</div>
